import template from './has-furniture.jade';
import itemsHasNo from '../../../enums/has-no';

export default angular
  .module('cian.addForm.aboutObjectHasFurniture', ['cian.addForm.fieldTypeSwitcher'])
  .directive('cianAfAboutObjectHasFurniture', () => ({
    scope: {},
    bindToController: {
      ad: '=',
      form: '=',
    },
    controller() {
      this.items = itemsHasNo;
    },
    controllerAs: 'hasFurniture',
    template,
  })).name;
